import angular from 'angular';

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('transportType', {
    url: '/transportType',
    templateProvider: () =>
      import(/* webpackChunkName: "transportType" */ './transportType.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'transportTypeCtrl as vm',
    requiredPermission: 'transportType',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "transportType" */ './transportType.controller'),
          import('../../extensions/init/ag-grid'),
          import('../../extensions/directives/select2'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
    },
  });
}

export default angular.module('app.transportType.routing', []).config(routes);
